import { Mapper } from "../../../../../base/utils/mapper";
import { TypeServiceModel } from "../../../../../domain/models/configuration/company/type-service.model";
import { TypeServiceEntity } from '../../entities/company/type-service.entity';

export class TypeServiceImplementationRepositoryMapper extends Mapper<TypeServiceEntity, TypeServiceModel> {
    mapFrom(param: TypeServiceEntity): TypeServiceModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeServiceModel): TypeServiceEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}